import { render, staticRenderFns } from "./purschemeimport.vue?vue&type=template&id=3877ff88&scoped=true&"
import script from "./purschemeimport.vue?vue&type=script&lang=js&"
export * from "./purschemeimport.vue?vue&type=script&lang=js&"
import style0 from "./purschemeimport.vue?vue&type=style&index=0&id=3877ff88&lang=scss&scoped=true&"
import style1 from "./purschemeimport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3877ff88",
  null
  
)

export default component.exports